import { MAX_CELL_WIDTH } from "ds/components/Table/constants";
import { TableColumnMeta } from "ds/components/Table/types";

export enum MODULE_PULL_REQUESTS_COLUMN_ID {
  STATUS = "STATUS",
  TITLE = "TITLE",
  PR = "PR",
  BRANCH = "BRANCH",
  AUTHOR = "AUTHOR",
  VENDOR = "VENDOR",
  DELTA = "DELTA",
  OPENED_AT = "OPENED_AT",
  UPDATED_AT = "UPDATED_AT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

export const MODULE_PULL_REQUESTS_TABLE_STORAGE_KEY = "modulePullRequestsColumnsConfig";

export const MODULE_PULL_REQUESTS_TABLE_COLUMNS_CONFIG: Record<
  MODULE_PULL_REQUESTS_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_PULL_REQUESTS_COLUMN_ID.STATUS]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.TITLE]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.TITLE,
    title: "Title",
    minWidth: 180,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.PR]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.PR,
    title: "PR",
    minWidth: 110,
    defaultWidth: 110,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.BRANCH]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.BRANCH,
    title: "Branch",
    minWidth: 120,
    defaultWidth: 210,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.AUTHOR]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.AUTHOR,
    title: "Author",
    minWidth: 120,
    defaultWidth: 170,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.VENDOR]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.VENDOR,
    title: "Vendor",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.DELTA]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.DELTA,
    title: "Delta",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.OPENED_AT]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.OPENED_AT,
    title: "Opened at",
    minWidth: 150,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.UPDATED_AT]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.UPDATED_AT,
    title: "Updated at",
    minWidth: 150,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: {
    id: MODULE_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS,
    title: "Pull request actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};
